import AnimalCrossword from "../../components/UKG/GeneralAwareness/AnimalCrossword";
import AnimalQuiz from "../../components/UKG/GeneralAwareness/AnimalQuiz";
import ChooseAnimalType from "../../components/UKG/GeneralAwareness/ChooseAnimalType";
import MatchImages from "../../components/UKG/GeneralAwareness/MatchAnimal";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/animals/crossword", title: "Crossword", component: AnimalCrossword},
    { url: "/ukg/general-awareness/animals/quiz", title: "Quiz", component: AnimalQuiz},
    { url: "/ukg/general-awareness/animals/match-images", title: "Match Images", component: MatchImages},
    { url: "/ukg/general-awareness/animals/choose-types", title: "Choose Animal", component: ChooseAnimalType},
];


export default topics;